import { displayToastMessage } from 'components/ToastMessage';
import { useQueryParams } from 'hooks/useSearchQueryParams';
import DefaultLayout from 'layouts/defaultLayout';
import { type FC, useEffect, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import type { EligibilityProps } from './Eligibility.types';
import { EligibilityQuestions } from './steps';

const Eligibility: FC<EligibilityProps> = () => {
  const { expired } = useQueryParams<{ expired: string }>();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (expired) {
      displayToastMessage(
        'ERROR',
        'Your submission has expired. Please start a new one to proceed.',
      );
      navigate('/', { replace: true });
    }
  }, [expired]);

  useEffect(
    () => () => {
      toast.dismiss();
    },
    [],
  );

  return (
    <DefaultLayout renderStepper={false}>
      <EligibilityQuestions />
    </DefaultLayout>
  );
};

export default Eligibility;
